import React, { useState, useEffect } from "react";
import axios from "axios";
import "./popup.css";

const Popup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "", // matches backend
    mail: "",  // matches backend
    place: "",
  });

  const [posterImage, setPosterImage] = useState(null);

  // Fetch poster image from backend
  useEffect(() => {
    const fetchPoster = async () => {
      try {
        const res = await axios.get("https://siteapi.flytutor.in/admin/eventposter"); // poster route
        if (res.data.length > 0) {
          const imageId = res.data[0]._id;
          setPosterImage(`https://siteapi.flytutor.in/admin/eventposter/${imageId}`);
        } else {
          setPosterImage(null);
        }
      } catch (err) {
        console.error("Error fetching poster:", err);
        setPosterImage(null);
      }
    };
    fetchPoster();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://siteapi.flytutor.in/admineventposter", formData);
      alert("✅ Thank you! Your details have been submitted.");
      setFormData({ name: "", phone: "", mail: "", place: "" });
      onClose();
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("❌ Something went wrong. Please try again.");
    }
  };

  // Hide popup completely if no poster
  if (!posterImage) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>✖</button>
        <div className="popup-body">
          <div className="popup-image">
            <img src={posterImage} alt="Event Poster" />
          </div>
          <div className="popup-form">
            <h2>Enter Your Details</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="mail"
                placeholder="Email Address"
                value={formData.mail}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="place"
                placeholder="Place"
                value={formData.place}
                onChange={handleChange}
                required
              />
              <button type="submit" className="popup-submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
